import React from "react";
import OrderSummary from "../OrderSummary";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import { useAppSelector } from "../../../../redux/app/hooks";
import { RootState } from "../../../../redux/app/store";
import ExecutedOrdersTable from "./ExecutedOrdersTable";

const ExecutedOrders = () => {
  const { executedOrders } = useAppSelector((state: RootState) => state.orders);

  const tabList = [
    {
      id: 1,
      name: "Executed Orders",
      count: executedOrders?.meta?.totalItems ?? 0,
    },
  ];

  console.log(executedOrders);

  return (
    <div className=" flex flex-col gap-6 p-4  sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Order Management</h1>
      </div>
      <OrderSummary />
      <WhiteTitledCard>
        <div className="px-6">
          <div className="flex space-x-4 items-center">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2
                text-black border-b-2 border-primary
                   `}
              >
                <span>{tab.name}</span>
                {
                  <span
                    className={"bg-lightPurple px-2  text-accent rounded-md"}
                  >
                    {tab?.count}
                  </span>
                }
              </div>
            ))}
          </div>
        </div>
        <ExecutedOrdersTable />
      </WhiteTitledCard>
    </div>
  );
};

export default ExecutedOrders;
